import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  { path: "/index.html", component: () => import("../views/Home.vue") },
  {
    path: "/guest",
    name: "Guest",
    component: () => import("../views/Guest.vue")
  },
  {
    path: "/out",
    name: "Sign Out",
    component: () => import("../views/SignOut.vue")
  },
  {
    path: "/pickup",
    name: "Pickup",
    component: () => import("../views/Pickup.vue")
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue"),
    beforeEnter: (to, from, next) => {
      const password = prompt("Password Required.");

      if (password == store.state.password) {
        return next();
      } else if (password == null) {
        return next("/");
      } else {
        return next("/");
      }
    }
  },
  {
    path: "/overtime",
    name: "Overtime",
    component: () => import("../views/Overtime.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
